import { combineReducers } from 'redux'

import { reducers as auth } from '../../auth'
import { reducers as cmsJobs } from '../../cmsPage'
import { reducers as companyJobs } from '../../companyJobs'
import { reducers as company } from '../../companyProfile'
import { reducers as errorPage } from '../../errorPage'
import { reducers as internalLinks } from '../../internalLinks'
import { reducers as jobapplication } from '../../jobapplication'
import { reducers as job } from '../../jobDetail'
import { reducers as jobmail } from '../../jobmail'
import { reducers as jobmailActivateError } from '../../jobmailActivateError'
import { reducers as jobmailUnsubscribePage } from '../../jobmailUnsubscribePage'
import { reducers as landingPage } from '../../landingPage'
import { reducers as landingPageCatalog } from '../../landingPageCatalog'
import { reducers as toast } from '../../notifications'
import { reducers as page } from '../../page'
import { reducers as ratingWidget } from '../../ratingWidget'
import { reducers as results } from '../../results'
import { reducers as search } from '../../search'
import { reducers as share } from '../../share'
import { reducers as similarJobs } from '../../similarJobs'
import { reducers as spellcheck } from '../../spellcheck'
import { reducers as tracking } from '../../tracking'
import { reducers as user } from '../../user'

export default combineReducers({
  search,
  company,
  errorPage,
  jobmail,
  jobmailActivateError,
  jobmailUnsubscribePage,
  jobapplication,
  companyJobs,
  cmsJobs,
  share,
  job,
  auth,
  toast,
  tracking,
  user,
  landingPage,
  landingPageCatalog,
  page,
  results,
  similarJobs,
  spellcheck,
  ratingWidget,
  internalLinks
})
